import { Component, OnInit } from '@angular/core';
import { AdmihairBaseComponent } from '../../../admihair-base.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PspService } from 'src/app/admihair/service/psp.service';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { Psp } from 'src/app/admihair/api/dto/psp';
import { PspMetadados } from 'src/app/admihair/api/dto/psp-metadados';
import { Empresa } from 'src/app/admihair/api/dto/empresa';
import { PspConfiguracaoEmpresa } from 'src/app/admihair/api/dto/psp-configuracao-empresa';
import { PspConfiguracaoEmpresaMetadata } from 'src/app/admihair/api/dto/psp-configuracao-empresa-metadata';
import { PspConfiguracaoEmpresaService } from 'src/app/admihair/service/psp-configuracao.service';

@Component({
  selector: 'app-configuracao-pix-inserir',
  templateUrl: './configuracao-pix-inserir.component.html',
  styleUrls: ['./configuracao-pix-inserir.component.scss']
})
export class ConfiguracaoPixInserirComponent extends AdmihairBaseComponent implements OnInit {


  progressoRequisicao: boolean = false;
  listaPsps: Psp[] = [];
  pspSelecionado?: Psp;
  metadadadosPsp: PspMetadados[] = [];
  formulario!: FormGroup;
  empresaSelecionada?: Empresa
  loadingForm: boolean = false;

  tiposChavePix: string[] = [
    'NENHUMA', 'EMAIL',
    'CPF', 'CNPJ',
    'CELULAR', 'ALEATORIA'
  ];
  tipoChavePixSelecionada?: string;

  constructor(private fb: FormBuilder,
    private pspService: PspService,
    private pspConfiguracaoEmpresaService: PspConfiguracaoEmpresaService,
    erroService: ErroService, storageService: UtilStorageService) {
    super(erroService, storageService)
  }

  ngOnInit(): void {
    this.permissaoInserir = this.verificarPermissao('PERM_INSERIR_CANAL_DE_INDICACAO')
    this.empresaSelecionada = this.getEmpresa();
    this.buscarPsps();
  }

  buscarPsps() {
    this.pspService.listar().subscribe({
      next: (data: Psp[]) => {
        this.listaPsps = data;
      },
      error: (err: any) => {
        this.exibirMensagemErro(err);
      }
    })
  }

  selecionarPsp() {
    this.loadingForm = true;
    this.pspService.buscarMetadados(this.pspSelecionado?.id).subscribe({
      next: (data: PspMetadados[]) => {
        this.metadadadosPsp = data;
        this.montarForm();
      },
      error: (err: any) => {
        this.loadingForm = false;
        this.exibirMensagemErro(err);
      }
    })
  }

  montarForm() {
    const grupo = this.fb.group({});
    this.metadadadosPsp.forEach(f => {
      const validator = [];
      //if(f.requerido) validators.push(Validators.required);
      grupo.addControl(f.chave, this.fb.control(null));
    })
    this.formulario = grupo;
    this.loadingForm = false;
  }

  salvar() {
    if (this.formulario && this.formulario.valid) {

      this.progressoRequisicao = true;
      const formValues = this.formulario.value;

      const listaMetadados: PspConfiguracaoEmpresaMetadata[] = Object.keys(formValues).map(chave => ({
        chave: chave,
        valor: formValues[chave]
      }));

      const configuracoes: PspConfiguracaoEmpresa = {
        pspId: this.pspSelecionado?.id,
        tipoChavePix: this.tipoChavePixSelecionada,
        empresaId: this.getEmpresa().id,
        metadados: listaMetadados
      };

      this.pspConfiguracaoEmpresaService.salvar(configuracoes).subscribe({
        next: () => {
          this.progressoRequisicao = false;
          this.reiniciarFormulario();
          this.exibirMensagemSucesso();
        },
        error: (err: any) => {
          this.progressoRequisicao = false;
          this.exibirMensagemErro(err);
        }
      })
    } else {
      this.exibirMensagemErroPadrao();
    }

  }

  reiniciarFormulario() {
    this.metadadadosPsp = [];
    this.pspSelecionado = undefined;
    this.tipoChavePixSelecionada = undefined;
    this.formulario.reset();
  }

}
